// rounds up the demical value
export function twoDecimalLimit(num) {
    return (Math.round(num * 100) / 100)
}

// displays number as a string with two fixed decimals
export function displayTwoDecimal(num){
    return Number.parseFloat(num).toFixed(2)
}